import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to Customer's Products page ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-9 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Product Variants")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_VariantConfigurationModal = _resolveComponent("VariantConfigurationModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "popupNotification" }, null, 512),
    _createVNode(_component_VariantConfigurationModal, {
      show: _ctx.showVariantConfigurationModal,
      size: _ctx.variantConfigurationModalOptions?.size,
      "width-inches": _ctx.variantConfigurationModalOptions?.widthInches,
      "height-inches": _ctx.variantConfigurationModalOptions?.heightInches,
      variant: _ctx.variantConfigurationModalOptions?.variant,
      image: _ctx.image,
      "paper-id": _ctx.paperId,
      onClose: _ctx.closeVariantConfigurationModal
    }, null, 8, ["show", "size", "width-inches", "height-inches", "variant", "image", "paper-id", "onClose"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "btn btn-success",
          to: `/customers/${_ctx.$route.params.customerId}`
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_4
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.variants?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Grid, {
              "data-items": _ctx.variants,
              columns: _ctx.columns
            }, {
              printSize: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getWidth(props.dataItem)) + " x " + _toDisplayString(_ctx.getHeight(props.dataItem)), 1)
                ])
              ]),
              sizeAndFraming: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.sizeText(props.dataItem)) + " " + _toDisplayString(_ctx.frameText(props.dataItem)), 1)
                ])
              ]),
              customFinishing: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  (!props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getCustomFinishing(props.dataItem)), 1))
                    : _createCommentVNode("", true),
                  (props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "btn btn-success",
                          onClick: ($event: any) => (_ctx.openVariantConfigurationModal(props.dataItem))
                        }, " Configuration ", 8, _hoisted_12)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              customFinishingDetails: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  (props.dataItem.CustomFinishingDetails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(props.dataItem.CustomFinishingDetails), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              yourCost: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.ImagePricingSizeConfiguration.PriceExcludingVat) + _toDisplayString(_ctx.currencySymbol), 1)
                ])
              ]),
              sku: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.SKU), 1)
                ])
              ]),
              actions: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.duplicateVariant(props.dataItem.Id)),
                    disabled: _ctx.isCanvas(props.dataItem)
                  }, " Duplicate ", 8, _hoisted_14),
                  (props.dataItem.IsCustomVariant && !props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "btn btn-danger mx-2",
                        onClick: ($event: any) => (_ctx.deleteVariant(props))
                      }, " Delete ", 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (props.dataItem.IsCustomVariant && props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "btn btn-danger mx-2",
                        onClick: ($event: any) => (_ctx.cancelEditVariant(props))
                      }, " Cancel ", 8, _hoisted_16))
                    : _createCommentVNode("", true),
                  (props.dataItem.IsCustomVariant && !props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: "btn btn-success",
                        onClick: ($event: any) => (_ctx.editVariant(props.dataItem))
                      }, " Edit ", 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  (props.dataItem.IsCustomVariant && props.dataItem.isEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "btn btn-success",
                        disabled: !props.dataItem.CustomFinishingDetails,
                        onClick: ($event: any) => (_ctx.saveVariant(props.dataItem))
                      }, " Save ", 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["data-items", "columns"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}